<mat-dialog-content>
  <form [formGroup]="evaluationForm">
    <glxy-form-field>
      <glxy-label>{{ label | translate }}</glxy-label>
      <textarea matInput formControlName="comment"></textarea>
    </glxy-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'INBOX.CANCEL' | translate }}
  </button>
  <button color="primary" mat-flat-button (click)="submit()">
    {{ 'INBOX.SUBMIT' | translate }}
  </button>
</mat-dialog-actions>
